import { aboutData } from '@/mocks/home';

export default function AboutSection() {
  return (
    <section id="about" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          <div className="flex-1 w-full">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-6">
              {aboutData.title}
            </h2>
            <div className="space-y-4">
              {aboutData.paragraphs.map((para, idx) => (
                <p key={idx} className="text-foreground-600 text-sm md:text-base leading-relaxed">
                  {para}
                </p>
              ))}
            </div>
          </div>

          <div className="w-full lg:w-auto flex-shrink-0">
            <div className="grid grid-cols-2 gap-4 md:gap-5">
              {aboutData.stats.map((stat, idx) => (
                <div
                  key={idx}
                  className="bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6 text-center min-w-[120px]"
                >
                  <div className="font-heading text-2xl md:text-3xl font-black text-primary-500 mb-1">
                    {stat.value}
                  </div>
                  <div className="text-xs text-foreground-400 font-medium">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}